import { combineReducers } from "redux";
import auth from "src/pages/auth/reducer";
import cart from "src/pages/cart/reducer";
import { LOGOUT } from "./actions";
import commonReducer from "./common-reducer";

const appReducer = combineReducers({
  commonReducer: commonReducer,
  auth: auth,
  cart: cart,
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT) {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
